export const UPDATE_QUOTATION_LIST = "UPDATE_QUOTATION_LIST";
export const QUOTATION_LIST_LOADING = "GET_QUOTATION_LIST";
